import { sanitizeFileName } from '../../Scaap/utils/xlsx/miniXlsx';
import { labelCentro } from '../../../features/labels/labels';
// nanoox/services/nanooxService.js

/**
 * Fetch consolidated centers data for Nanoox.
 *
 * @param {string} page - Nombre de la app/endpoint (ej: "nanoox").
 * @param {string} serverUrl - URL base del servidor.
 * @returns {Promise<Object>} - Objeto con regiones, áreas y centros.
 */
export async function fetchConsolidadoCenters(PAGE, servidor) {
  try {
      let SERVER_URL = await servidor;        
      // Si no se pudo obtener la URL del servidor, retornar null
      if (SERVER_URL === "Error en conexión") {
          console.error("No se pudo establecer una conexión con el servidor.");
          return {};
      }
      const endpoint = `/${PAGE}/consolidado_estados`;
      const fullUrl = `${SERVER_URL}${endpoint}`;
      const response = await fetch(fullUrl, {
          method: 'GET',
          credentials: 'include',         // ← aquí también
          headers: {
              'Content-Type': 'application/json',
          },
          keepalive: false
      });

      // console.log('respuesta servidor', response)

      if (!response.ok) {
          throw new Error('Error en la solicitud');
      }

      const result = await response.json();
      // console.log('Respuesta del servidor:', result);
      
      // Retornar el resultado
      return result;
  } catch (error) {
      console.error('Error:', error);
      return {};  // Retornar un objeto vacío en caso de error
  }
};




/**
 * Fetch data from Nanoox center API.
 *
 * @param {Object} params
 * @param {string} params.region - Región del centro.
 * @param {string} params.area - Área del centro.
 * @param {string} params.centro - Identificador del centro.
 * @param {string} [params.centerName] - Nombre alternativo del centro.
 * @param {string} params.serverUrl - Base URL del servidor.
 * @returns {Promise<Object>} - Datos del centro.
 * @throws {Error} - Si la solicitud falla.
 */
export function decorateCenterResponse(data) {
  if (!data || typeof data !== "object") return data;

  const dataStatus = data.data_status;
  const dataStatusDetail = data.data_status_detail || data.error || "";

  if (dataStatus === "comap_only" || dataStatus === "sin_datos_recientes") {
    return {
      ...data,
      __dataStatus: dataStatus,
      __dataStatusDetail: dataStatusDetail,
    };
  }

  if (dataStatus === "sin_estructura" || dataStatus === "error") {
    return {
      ...data,
      __dataStatus: dataStatus,
      __dataStatusDetail: dataStatusDetail,
      __sinDatos: dataStatusDetail || "Centro sin datos disponibles",
    };
  }

  // Compatibilidad con servidores anteriores al contrato data_status.
  if (!dataStatus && data.error) {
    return {
      ...data,
      __sinDatos: data.error,
    };
  }

  return data;
}

export async function getCenterData({ region, area, centro, centerName, serverUrl }) {
  const centroId = centerName || centro;
  const url = `${serverUrl}/nanoox/get_data/${region}/${area}/${centroId}`;
  console.log(
    `%c➡️ [GET CENTER] ${centroId}`,
    "color: #00bcd4; font-weight: bold"
  );

  try {
    // console.log("Fetching Nanoox data:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      keepalive: false,
    });

    const data = await response.json();
// console.log('data',data)
    if (!response.ok) {
      console.log(
        `%c❌ [GET CENTER FAILED] ${centroId}`,
        "color: red"
      );
      throw new Error(data.mensaje || "Error intentando acceder al centro");
    }

    const decoratedData = decorateCenterResponse(data);
    const statusDetail = decoratedData?.__dataStatusDetail || decoratedData?.__sinDatos;

    if (statusDetail) {
      console.warn(
        `%c⚠️ [GET CENTER ${decoratedData?.__dataStatus || "SIN DATOS"}] ${centroId}: ${statusDetail}`,
        "color: #ffb300; font-weight: bold"
      );
    }

    console.log(
      `%c✅ [GET CENTER OK] ${centroId}`,
      "color: green"
    );
    // console.log('data',data)
    return decoratedData;
  } catch (error) {
    console.log(
      `%c🔥 [GET CENTER ERROR] ${centroId}`,
      "color: red; font-weight: bold"
    );
    // console.error("Hubo un error al acceder al centro:", error);
    throw error;
  }
}
//  https://test.itgchile.com/nanoox/get_data/fonchi/richi/salva


export async function downloadReport(endpoint, dateRange, reportType, setNotification_open, setNotification_msg, setNotification_status, servidor) {
  let Centro = localStorage.getItem('CENTRO');
    
  try {
        const SERVER_URL = servidor;
        const fullUrl = `${SERVER_URL}${endpoint}`;
        console.log("%cSERVIDOR", "color: green; font-size: 50px", servidor);
        // console.log("%cENDPOINT", "color: blue; font-size: 50px", endpoint);
        // console.log("%FULLURL", "color: blue; font-size: 50px", fullUrl);

        const response = await fetch(fullUrl, {
            method: 'POST',
            credentials: 'include', 
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dateRange)
        });

        if (!response.ok) {
            setNotification_msg(`Error al generar el reporte: ${response.status}`);
            setNotification_open(true);
            setNotification_status('error');
            return { error: true, message: `Error en la solicitud: ${response.status}` };
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;

        const label = labelCentro({ region: localStorage.getItem('REGION'), area: localStorage.getItem('AREA'), centro: Centro }, '');
        const nombreVisible = label ? sanitizeFileName(label) : Centro;
        let reportName;
        const startDateStr = dateRange.startDate.split('/').reverse().join('-');
        const endDateStr = dateRange.endDate.split('/').reverse().join('-');
        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);

        if (reportType === 'reporteSensores') {
            reportName = startDate.getTime() === endDate.getTime() ? `Nanoox ${nombreVisible} ${startDateStr}.xlsx` : `Nanoox ${nombreVisible} ${startDateStr}_${endDateStr}.xlsx`;
        } else if (reportType === 'reporteHistorialControl') {
            reportName = startDate.getTime() === endDate.getTime() ? `Nanoox Historial de Control ${nombreVisible} ${startDateStr}.xlsx` : `Nanoox Historial de Control ${nombreVisible} ${startDateStr}_${endDateStr}.xlsx`;
        }

        a.download = reportName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);

        return { error: false };
    } catch (error) {
        setNotification_msg(`Fetch failed in downloadReport: ${error}`);
        setNotification_open(true);
        setNotification_status('error');
        return { error: true, message: `Fetch failed in downloadReport : ${error}` };
    }
}

export async function tipo_control(servidor) {
try {
    let SERVER_URL = servidor

    const Region = localStorage.getItem('REGION')
    const Area = localStorage.getItem('AREA')
    const Centro = localStorage.getItem('CENTRO')


    if (SERVER_URL === "Error en conexión") {
    console.error("No se pudo establecer una conexión con el servidor.");
    return {};
    }

    const endpoint = `/NANOOX/tipo_control/${Centro}/${Area}/${Region}`;
    const fullUrl = `${SERVER_URL}${endpoint}`;
    //console.log('fullUrl', fullUrl);

    const response = await fetch(fullUrl, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
    });

    //console.log('respuesta servidor', response);

    if (!response.ok) {
    throw new Error('Error en la solicitud');
    }

    const result = await response.json();
//   console.log('Respuesta del servidor:', result);

    return result; // Asegúrate de retornar el resultado aquí
} catch (error) {
    console.error('Error:', error);
    return {}; // Retorna un objeto vacío en caso de error
}
}
